class ProviderPickerCtrl {
    constructor(PROVIDERS, $state) {
        'ngInject';
        this.PROVIDERS = PROVIDERS;
        this.$state = $state;
    }
    selectProvider (provider) {
        this.$state.go('login', {provider}, {});
    }
}
  
export default {
    templateUrl: "user/provider-picker/provider-picker.component.html",
    controller: ProviderPickerCtrl
}